<template>
  <div>

    <div v-if="userLogged.user.isConnectedGoogle">
      <Alert type="success">
        <span>
          Conta conectada ao<img class="img-google"
            src="https://www.gstatic.com/images/branding/product/1x/calendar_48dp.png" /> Google Agenda
        </span>
        <Button _key="btnTools" classIcon="fa-solid fa-screwdriver-wrench" backGroundColor="#F2B607" color="white"
          size="small" :clicked="openTools" />
        <Button _key="btnRequestDisconnect" classIcon="fa-solid fa-right-from-bracket" backGroundColor="#EF294B"
          color="white" size="small" :clicked="disconnect" />
      </Alert>
    </div>

    <div v-else>
      <Alert type="info">
        <span>
          Conta <b>NÃO</b> conectada ao <img class="img-google"
            src="https://www.gstatic.com/images/branding/product/1x/calendar_48dp.png" /> Google Agenda
        </span>
        <Button _key="btnGetLink" title="Conectar" backGroundColor="#1864CB" color="white" size="small"
          :clicked="getLink" />
      </Alert>
    </div>

    <Modal title="Configuração Google Agenda" :width="650" :height="750" v-if="showModal('tools')">
      <div v-if="!loading">
        <ErrorsGoogle :errors="errors" />
        <b-tabs>
          <b-tab title="Sincronizar">
            <Toggle title="Tarefas" :color="'#8E24AA'" v-model="config.showJob" />
            <div v-if="this.hasRule('Operational') || this.hasRule('Rental')">
              <Toggle title="Saídas" :color="'#009183'" v-model="config.showDelivery" />
              <Toggle title="Locação" :color="'#957367'" v-model="config.showPeriod" />
              <!--<Toggle title="Orçamento" :color="'#4BB4E2'" v-model="config.showProgress" />-->
              <Toggle title="Retornos" :color="'#3D4EAE'" v-model="config.showDevolution" />
            </div>
            <div v-if="this.hasRule('Maintenance')">
              <Toggle title="Manutenção" :color="'#E7BA51'" v-model="config.showMaintenance" />
            </div>
          </b-tab>
          <b-tab title="Notificações">
            <NotificationSetting v-model="config.notifications" />
          </b-tab>
        </b-tabs>
        <div class="text-center">
          <br>
          <Button _key="synchronize" title="Sincronizar" classIcon="fa-brands fa-google" backGroundColor="#3D4EAE"
            color="white" size="small" :clicked="synchronize" />
        </div>
      </div>
      <div class="div-log" v-else>
        <LogoSection />
        <div class="title text-center" v-if="totalEventsCreated >= 1">
          Sincronizando <span class="total">{{ totalEventsCreated }}</span> de <span class="total">{{ totalEvents
          }}</span>
        </div>
        <div class="text-center" v-else>Estabelecendo conexão com o Google Agenda...</div>
        <br>
        <Loading type="line" :center="true" />
        <AnimatedPhrase
          :phrases="['Aguarde...', 'Isso pode levar alguns ou vários minutos', 'Não feche essa janela...']" />
      </div>
    </Modal>
  </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import AnimatedPhrase from "@nixweb/nixloc-ui/src/component/layout/AnimatedPhrase";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Toggle from "@nixweb/nixloc-ui/src/component/forms/Toggle";
import NotificationSetting from './NotificationSetting.vue';
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ErrorsGoogle from './ErrorsGoogle.vue'

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: 'GoogleCalendar',
  components: {
    AnimatedPhrase,
    Alert,
    Button,
    InputNumber,
    Modal,
    Loading,
    Toggle,
    ErrorsGoogle,
    NotificationSetting,
    LogoSection: {
      functional: true,
      render(h) {
        return h("div", { class: "google-logos", ErrorsGoogle }, [
          h("div", { class: "google-logo" }, [
            h("img", {
              attrs: {
                src: "https://www.gstatic.com/images/branding/product/1x/calendar_48dp.png",
                alt: "Google Calendar"
              }
            })
          ]),
          h("div", { class: "google-plus" }, "+"),
          h("div", [
            h("img", {
              class: "google-logo-nix",
              attrs: {
                src: "https://nixloc.com.br/wp-content/themes/nixloc/shared/images/logo/nixloc.svg",
                alt: "Nixloc"
              }
            })
          ])
        ]);
      }
    }
  },
  data() {
    return {
      urlGetLink: "/api/v1/google/calendar-request-login",
      urlGetById: "/api/v1/google/get-by-id",
      urlSynchronize: "/api/v1/google/synchronize-calendar",
      urlCreateEvent: "/api/v1/google/create-event",
      isConnected: false,
      config: {
        showJob: true,
        showDelivery: true,
        showPeriod: false,
        showProgress: false,
        showDevolution: true,
        showMaintenance: true,
        notifications: [],
      },
      loading: false,
      errors: [],
      totalEvents: 0,
      totalEventsCreated: 0,
    }
  },
  mounted() {
    this.getById();
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("generic", ["event", "showModal"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapActions("generic", ["getApi", "postApi"]),
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading", "addEvent"]),
    ...mapMutations("user", ["updateStatusGoogle"]),
    openTools() {
      this.openModal("tools");
      this.removeLoading(["btnTools"]);
    },
    getById() {
      let params = {
        url: this.urlGetById,
        obj: { userId: this.userLogged.user.id },
      };
      this.getApi(params).then((response) => {
        var config = JSON.parse(response.content.config);
        this.config.showJob = config.ShowJob;
        this.config.showDelivery = config.ShowDelivery;
        this.config.showPeriod = config.ShowPeriod;
        this.config.showProgress = false;
        this.config.showDevolution = config.ShowDevolution;
        this.config.showMaintenance = config.ShowMaintenance;
        config.Notifications.forEach(item => {
          var newNotification = { time: item.Time, type: item.Type, unit: item.Unit, };
          this.config.notifications.push(newNotification);
        });
      });
    },
    synchronize() {
      this.loading = true;
      let params = {
        url: this.urlSynchronize,
        obj: {
          firstSynchro: true,
          userId: this.userLogged.user.id,
          showJob: this.config.showJob,
          showDelivery: this.config.showDelivery,
          showPeriod: this.config.showPeriod,
          showProgress: false,
          showDevolution: this.config.showDevolution,
          showMaintenance: this.config.showMaintenance,
          notifications: this.config.notifications,
        },
        notNotifyToast: true
      };
      this.postApi(params).then(response => {
        this.totalEvents = response.content.length;

        if (this.totalEvents == 0) this.hideModal();

        let self = this;
        response.content.forEach((event, index) => {
          setTimeout(() => {
            self.createEvent(event);
          }, index * 1000);
        });

        this.loading = false;
        this.removeLoading(["synchronize"]);
      });
    },
    createEvent(event) {
      this.loading = true;
      let params = {
        url: this.urlCreateEvent,
        obj: event,
        notNotifyToast: true
      };
      this.postApi(params).then(response => {
        if (response.success) {
          this.totalEventsCreated++;
          if (this.totalEventsCreated == this.totalEvents) {
            this.totalEventsCreated = 0;
            this.totalEvents = 0;
            this.loading = false;
            this.removeLoading(["synchronize"]);
            this.hideModal();
          }
        }
      });
    },
    getLink() {
      let params = {
        url: this.urlGetLink,
        obj: { userId: this.userLogged.user.id },
      };
      this.getApi(params).then((response) => {
        let self = this;
        setTimeout(function () {
          window.location.href = response.content;
          self.removeLoading(["btnGetLink"]);
        }, 900);
      });
    },
    disconnect() {
      let self = this;
      setTimeout(function () {
        self.$router.replace({
          name: "integrationReturn",
          params: { statusReturn: "disconnect" },
        });
        self.removeLoading(["btnRequestDisconnect"]);
      }, 300);
    }
  },
}
</script>

<style scoped>
.img-google {
  width: 25px;
  height: 25px;
}

.google-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.google-logo-nix {
  width: 120px;
}

.google-logo img {
  width: 48px;
  height: 48px;
}

.google-plus {
  font-size: 40px;
  margin: 0 30px;
  color: #0984e3;
}

.div-log {
  padding: 50px;
}

.total {
  font-size: 16px;
}
</style>
